module.exports = __webpack_public_path__ + "static/media/pagenotfound.8c1031d8.gif";